import { WifiOff } from 'lucide-react'
import { useOnline } from '@hooks/useOnline.ts'
import { useRouter } from '@router'
import styles from './OfflineBanner.module.css'

export const OfflineBanner = () => {
	const online = useOnline()
	const { path } = useRouter()
	if (online) return null
	// Groceries is the one app that still takes ticks offline.
	const groceries = path.replace(/^\//, '').split('/')[0] === 'groceries'
	return (
		<div className={styles.banner} role="status">
			<WifiOff size={14} aria-hidden="true" />
			{groceries
				? "You're offline. You can still tick items, but other changes are paused until you reconnect."
				: "You're offline. You can browse, but changes are paused until you reconnect."}
		</div>
	)
}
